import { createSlice } from '@reduxjs/toolkit'

const defaultValue = {
    show: false
}

export const emailSlice = createSlice({
    name: 'email',
    initialState: defaultValue,
    reducers: {
        showMessage: (state, action) => {
            return action.payload
        },
        deleteMessage: () => {
            return defaultValue
        }
    }
})

export const { showMessage, deleteMessage } = emailSlice.actions
export default emailSlice.reducer